import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingApiService } from '../../services/api/setting-api.service';
import { ModalService } from '../../../../core/services/modal/modal.service';
import { WebConfigService } from '../../../../core/services/web-config/web-config.service';

interface FieldDef {
  key: string;
  label: string;
  hint?: string;
}

@Component({
  selector: 'app-setting-web-config',
  templateUrl: './setting-web-config.component.html',
  styleUrl: './setting-web-config.component.css'
})
export class SettingWebConfigComponent implements OnInit {

  form: FormGroup;
  loading = false;
  saving = false;

  fields: FieldDef[] = [
    { key: 'percentSetList', label: '% บวกทุนเซ็ตสินค้าปกติ', hint: 'ใช้คำนวณ "ทุน+%" ใน Product Set' },
    { key: 'percenTikTokSetList', label: '% บวกทุนเซ็ต TikTok', hint: 'ใช้คำนวณ "ทุน+%" ใน TikTok Set' },
    { key: 'percentPriceList', label: '% บวกทุน Price List', hint: 'ใช้คำนวณ "ทุน+%" ใน Price List' },
    { key: 'costPriceIndex', label: 'Index ราคาทุน (ทั่วไป)', hint: 'ตำแหน่ง index ของช่องทุนใน prices array' },
    { key: 'tiktokCostPriceIndex', label: 'Index ราคาทุน (TikTok)', hint: 'ตำแหน่ง index ของช่องทุนสำหรับ TikTok' },
    { key: 'srpPriceIndex', label: 'Index ราคา SRP', hint: 'ตำแหน่ง index ของช่อง SRP ใน prices array' },
  ];

  constructor(
    private fb: FormBuilder,
    private settingApiService: SettingApiService,
    private modalService: ModalService,
    private webConfigService: WebConfigService,
  ) {
    const group: { [k: string]: any } = {};
    for (const f of this.fields) {
      group[f.key] = [null, [Validators.required, Validators.min(0)]];
    }
    this.form = this.fb.group(group);
  }

  ngOnInit(): void {
    this.load();
  }

  async load() {
    this.loading = true;
    try {
      const res: any = await this.settingApiService.getWebConfig();
      if (res?.success && res.data) {
        const patch: any = {};
        for (const f of this.fields) {
          patch[f.key] = res.data[f.key] ?? 0;
        }
        this.form.patchValue(patch);
      }
    } finally {
      this.loading = false;
    }
  }

  async submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const body = this.form.getRawValue();
      const res: any = await this.settingApiService.updateWebConfig(body);
      if (res?.success) {
        this.webConfigService.applyUpdate(res.data ?? body);
        this.modalService.openModal('success', 'บันทึกสำเร็จ', 'ค่า config ถูกอัพเดตแล้ว');
      } else {
        this.modalService.openModal('fail', 'บันทึกไม่สำเร็จ', '');
      }
    } finally {
      this.saving = false;
    }
  }
}
